import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { VersionService } from './app/core/services/version.service';

bootstrapApplication(App, appConfig)
  .then((appRef) => {
    if (typeof console !== 'undefined' && console.debug) {
      appRef.injector.get(VersionService).load().subscribe((metadata) => {
        console.debug('App version', metadata);
      });
    }
  })
  .catch((err) => console.error(err));
